import DiagnosticUiBadge from "@/components/sat/DiagnosticUiBadge";

/**
 * Envuelve contenido técnico de auditoría SAT; no renderiza nada si el modo diagnóstico está apagado.
 */
export default function DiagnosticUiPanel({
  enabled,
  children,
  className = "",
  badgePosition = "bottom",
}) {
  if (!enabled) return null;

  const badge =
    badgePosition === "top" ? (
      <DiagnosticUiBadge className="mb-2 mt-0" />
    ) : (
      <DiagnosticUiBadge />
    );

  return (
    <div className={`relative ${className}`} data-testid="sat-ui-diagnose-panel">
      {badgePosition === "top" ? badge : null}
      {children}
      {badgePosition === "bottom" ? badge : null}
    </div>
  );
}
